// app/javascript/entrypoints/application.ts
import '../entrypoints/application.css'
import { createInertiaApp, router } from '@inertiajs/react'
import { createElement } from 'react'
import { createRoot } from 'react-dom/client'
import i18n from '@/i18n'
import { I18nextProvider } from 'react-i18next'

// Ensure fresh props when navigating via browser back / forward buttons (e.g. from active test)
let isPopstate = false
window.addEventListener('popstate', () => {
  isPopstate = true
})

router.on('navigate', () => {
  if (isPopstate) {
    isPopstate = false
    setTimeout(() => {
      router.reload({ preserveScroll: true })
    }, 20)
  }
})

document.addEventListener('DOMContentLoaded', () => {
  const el = document.getElementById('app') || document.querySelector<HTMLElement>('[data-page]')

  if (el) {
    const pageData = el.dataset.page
      ? JSON.parse(el.dataset.page)
      : undefined

    createInertiaApp({
      page: pageData,
      resolve: (name) => {
        const pages = import.meta.glob('../pages/**/*.tsx', { eager: true }) as Record<
          string,
          { default: React.ComponentType }
        >
        const page = pages[`../pages/${name}.tsx`]
        if (!page) throw new Error(`Page not found: ${name}`)
        return page
      },
      setup({ el, App, props }) {
        const root = createRoot(el)
        root.render(
          createElement(I18nextProvider, { i18n },
            createElement(App, props)
          )
        )
      },
      progress: {
        color: 'hsl(var(--primary))',
      },
    })
  }
})



